import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import Events from '@/pages/Events';
import About from '@/pages/About';
import Team from '@/pages/Team';
import JoinUs from '@/pages/JoinUs';
import Partnerships from '@/pages/Partnerships';
import People from '@/pages/People';
import Gallery from '@/pages/Gallery';
import Blog from '@/pages/Blog';
import MadeNotMadeUp from '@/pages/MadeNotMadeUp';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/events" element={<Events />} />
          <Route path="/about" element={<About />} />
          <Route path="/team" element={<Team />} />
          <Route path="/join-us" element={<JoinUs />} />
          <Route path="/partnerships" element={<Partnerships />} />
          <Route path="/people" element={<People />} />
          <Route path="/content/gallery" element={<Gallery />} />
          <Route path="/content/blog" element={<Blog />} />
          <Route path="/content/made-not-made-up" element={<MadeNotMadeUp />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;